import type { GeoJsonFeature } from "./ogc";


export const COLORS = {
  sensorVisible: [0, 155, 104],
  sensorHidden: [255, 0, 0],
  sensorOffline: [128, 128, 128],
  sensorRetired: [200, 200, 200],
  depthNone: [0, 155, 104],
  depthMinimal: [0, 204, 255],
  depthMinor: [255, 162, 68],
  depthModerate: [254, 77, 76],
  depthMajor: [215, 77, 254],
}


export const sensorToColor = (f: GeoJsonFeature): [number, number, number] => {
  switch (f.properties.fk_status) {
    case 'visible':
      // if (!f.properties.last_measurement_time || f.properties.last_measurement_time.getTime() < new Date().getTime() - 2 * 60 * 60 * 1000) {
      //   // return [128, 0, 0];
      //   // return [200, 200, 200];
      //   return [128, 128, 128];
      // }
      // return [0, 204, 255];
      return [0, 155, 104];
    case 'hidden':
      return [255, 0, 0];
    case 'offline':
      // return [200, 200, 200];
      return [160, 160, 160];
    case 'retired':
      return [30, 30, 30];
      // return [100, 100, 100];
      // return [200, 200, 200];
    default:
      return [0, 155, 104];
      // return [0, 204, 255];
  }
}

export const depthToColor = (depth: number): [number, number, number] => {
  if (!depth || depth <= 0) { // None
    // return [0, 204, 255];
    // return [0, 204, 255];
    return [0, 155, 104];
  }
  if (depth < 4) {  // Minimal
    return [0, 204, 255];
  }
  if (depth < 12) { // Minor
    // rgb(254, 77, 76)
    // return [253, 191, 75];
    // rgb(253, 191, 75)
    // rgba(255, 162, 68, 1)
    return [255, 162, 68];
  }
  if (depth < 24) { // Moderate
    // rgb(215, 77, 254)
    return [254, 77, 76];
  }
  return [215, 77, 254]; // Major
}

// export const depthToRadius = (depth: number) => {
//   return Math.round(depth ? 16 + 2 * depth / 24 : 8);
// }

export const mostRecentTime = (currentTime: Date, times: Date[]) => {
  if (currentTime) {
    for (const i in times) {
      if (times[i] > currentTime) return (i as unknown as number) - 1;
    }
  }
  return times.length - 1;
}
export const mostRecentDepth = (currentTime: Date, f: GeoJsonFeature) => {
  const depths: number[] = f.properties.depth_inches;
  const times: Date[] = f.properties.time;
  if (currentTime >= f.properties.end_time || currentTime < f.properties.start_time) {
    return 0;
  }
  const idx = mostRecentTime(currentTime, times.map(t => new Date(t)));
  return depths[idx] || 0;
}
export const insideEventTimeRange = (currentTime: Date, f: GeoJsonFeature) => {
  if (!currentTime) return false;
  return currentTime >= f.properties.start_time && currentTime <= f.properties.end_time;
}

